export default __webpack_public_path__ + "static/media/plus.bade596b.svg";